import { render, staticRenderFns } from "./PackingSlips.vue?vue&type=template&id=076afefe&scoped=true&"
import script from "./PackingSlips.vue?vue&type=script&lang=js&"
export * from "./PackingSlips.vue?vue&type=script&lang=js&"
import style0 from "./PackingSlips.vue?vue&type=style&index=0&id=076afefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076afefe",
  null
  
)

export default component.exports